import React from 'react'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import { Container } from 'reactstrap'
import CreateKML from '../../components/Common/Map/CreateKML'

export default function CreateKml() {
  return (
    <React.Fragment>
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title="Control Room" breadcrumbItem="Create Kml" />
        <CreateKML/>
        </Container>
        </div>
        </React.Fragment>
            
  )
}
